import { type PropsWithChildren, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

interface ClientPortalProps {
  selector: string
}

export function ClientPortal({ children, selector }: PropsWithChildren<ClientPortalProps>) {
  const ref = useRef<Element | null>()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    ref.current = globalThis.document.querySelector(selector)
    setMounted(true)
  }, [selector])

  return mounted && ref.current ? createPortal(children, ref.current) : null
}
